import { useRef } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className = "", lineClass = "", delay = 0, as = "span" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.1 });
  const Tag = as;
  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "112%" }}
            animate={inView ? { y: "0%" } : {}}
            transition={{ duration: 1.1, delay: delay + 0.12 * i, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const ClipImage = ({ image, className = "", imgClassName = "", parallax = 6, rounded = "rounded-3xl", sizes = "(max-width: 1024px) 100vw, 50vw" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.1 });
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${parallax}%`, `${parallax}%`]);
  return (
    <div ref={ref} className={className}>
      <motion.div
        initial={{ clipPath: "inset(16% 10% 16% 10% round 32px)", opacity: 0.5 }}
        animate={inView ? { clipPath: "inset(0% 0% 0% 0% round 24px)", opacity: 1 } : {}}
        transition={{ duration: 1.3, ease: EASE }}
        className={`relative overflow-hidden w-full h-full ${rounded}`}
      >
        <motion.img
          src={image.src}
          srcSet={image.srcSet}
          sizes={sizes}
          alt={image.alt}
          loading="lazy"
          style={{ y }}
          className={`w-full h-full object-cover scale-[1.14] will-change-transform ${imgClassName}`}
        />
      </motion.div>
    </div>
  );
};
